import { render } from "./OrganizerWorkspaceNav.vue?vue&type=template&id=184562c2&scoped=true"
import script from "./OrganizerWorkspaceNav.vue?vue&type=script&lang=js"
export * from "./OrganizerWorkspaceNav.vue?vue&type=script&lang=js"

import "./OrganizerWorkspaceNav.vue?vue&type=style&index=0&id=184562c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184562c2"]])

export default __exports__